import * as AcquisitionGenericActions from "./acquisition-generic.actions";
import * as AcquisitionGenericStoreSelectors from "./acquisition-generic.selectors";
import * as AcquisitionGenericStoreReducer from "./acquisition-generic.reducer";

export {
  AcquisitionGenericActions,
  AcquisitionGenericStoreSelectors,
  AcquisitionGenericStoreReducer,
};
